import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import React, { useContext } from "react";
import WorkOrderContext from "../context/WorkOrderContext";
import StoreContext from "../context/StoreContext";
import FeedbackContext from "../context/FeedbackContext";
import { useBebackApi } from "../hooks/useBebackApi";

const ChangeTimeModal = ({
  open,
  close,
  handleChangeTime,
  time,
  workOrder,
  setAlert,
  setPromisedTimeButton,
}) => {
  const { updateWorkOrder } = useBebackApi();
  const { fetchWorkOrders } = useContext(WorkOrderContext);
  const { storeId } = useContext(StoreContext);
  const { setIsLoading } = useContext(FeedbackContext);

  const handleIgnoreAlert = async () => {
    setIsLoading(true);
    setAlert(false);
    setPromisedTimeButton(false);
    const res = await updateWorkOrder({
      WO: workOrder.WO,
      promised_time_details: { ignore_update: true },
    });
    if (res && !res.error) {
      await fetchWorkOrders(storeId);
      close();
      setIsLoading(false);
    } else {
      alert("Couldn't ignore the alert");
    }
  };

  return (
    <Dialog
      open={open}
      onClose={close}
      disableEscapeKeyDown
      maxWidth="sm"
      fullWidth={true}
    >
      <div className="flex justify-between">
        <DialogTitle>Change time</DialogTitle>
        <IconButton
          aria-label="close modal"
          sx={{ padding: 1, margin: 1, height: "fit-content" }}
          onClick={close}
        >
          <CloseIcon />
        </IconButton>
      </div>
      <DialogContent dividers className="flex justify-between">
        <div className="flex items-center gap-3">
          <AccessTimeIcon />
          {time.toFormat("hh:mm a")}
        </div>
        <Button
          variant="text"
          color="error"
          className="font-bold"
          onClick={handleChangeTime}
        >
          Change Time
        </Button>
      </DialogContent>
      <DialogActions>
        <Button
          variant="text"
          color="success"
          className="font-bold"
          onClick={handleIgnoreAlert}
        >
          Ignore notification
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ChangeTimeModal;
